import { useContext } from "react";
import { TenantContext } from "@/context/TenantContext";

export function useTenant() {
  const context = useContext(TenantContext);
  if (context === undefined) {
    throw new Error("useTenant must be used within a TenantProvider");
  }
  return context;
}

/**
 * Convenience re-export: check if a feature flag is enabled for the current tenant.
 * Usage: const enabled = useFeatureEnabled("reporting");
 */
export function useFeatureEnabled(feature: string): boolean {
  const { isFeatureEnabled } = useTenant();
  return isFeatureEnabled(feature);
}
